import logo from "./logo.svg";
import "./App.css";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import NuevaContrasena from "./pantallas/NuevaContrasena";
import PaginaNoEncontrada from "./pantallas/PaginaNoEncontrada";
import Home from "./pantallas/Home";
import RestablecerContrasena from "./pantallas/RestablecerContrasena";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
function App() {
    // const location = useLocation();
    // const navigate = useNavigate();
    const theme = createTheme({
        palette: {
            mode: "light",
            primary: {
                main: "#e3007e",
            },
            secondary: {
                main: "#f50057",
            },
        },
        typography: {
            fontSize: 18,
            fontFamily: `"Monserrat","Roboto", "Helvetica", "Arial", sans-serif`,
        },
    });
    return (
        <>
            <CssBaseline />
            <ThemeProvider theme={theme}>
                <Routes>
                    <Route exact path={"/"} element={<Home />} />
                    <Route
                        path={"/nueva-contrasena"}
                        element={<NuevaContrasena />}
                    />
                    <Route
                        path={"/restablecer-contrasena"}
                        element={<RestablecerContrasena />}
                    />
                </Routes>
            </ThemeProvider>
        </>
    );
}

export default App;
